import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { useMemo } from 'react';
import { getFileOriginEditor } from '@/utils/spreadsheets';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var GoogleSheetsIcon = function GoogleSheetsIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M271.25 0H40.6875C18.3094 0 0 16.3841 0 36.4091V497.591C0 517.616 18.3094 534 40.6875 534H393.312C415.69 534 434 517.616 434 497.591V145.636L339.062 84.9545L271.25 0Z",
      fill: "#0F9D58"
    }), /*#__PURE__*/_jsx("path", {
      d: "M108.5 260.932V436.909H325.5V260.932H108.5ZM203.438 412.637H135.625V382.296H203.438V412.637ZM203.438 364.091H135.625V333.75H203.438V364.091ZM203.438 315.546H135.625V285.205H203.438V315.546ZM298.375 412.637H230.563V382.296H298.375V412.637ZM298.375 364.091H230.563V333.75H298.375V364.091ZM298.375 315.546H230.563V285.205H298.375V315.546Z",
      fill: "#F1F1F1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M271.249 0V109.227C271.249 129.343 289.457 145.636 311.936 145.636H433.999L271.249 0Z",
      fill: "#87CEAC"
    }), /*#__PURE__*/_jsx("path", {
      d: "M40.6875 0C18.3094 0 0 16.3841 0 36.4091V39.4432C0 19.4182 18.3094 3.03409 40.6875 3.03409H271.25V0H40.6875Z",
      fill: "white",
      fillOpacity: "0.2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M393.312 530.965H40.6875C18.3094 530.965 0 514.581 0 494.556V497.59C0 517.615 18.3094 534 40.6875 534H393.312C415.69 534 434 517.615 434 497.59V494.556C434 514.581 415.69 530.965 393.312 530.965Z",
      fill: "#263238",
      fillOpacity: "0.2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M311.936 145.636C289.457 145.636 271.249 129.343 271.249 109.227V112.261C271.249 132.377 289.457 148.67 311.936 148.67H433.999V145.636H311.936Z",
      fill: "#263238",
      fillOpacity: "0.1"
    })]
  }));
};

GoogleSheetsIcon.defaultProps = {
  width: "434",
  height: "534",
  viewBox: "0 0 434 534",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ExcelIcon = function ExcelIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M360.333 253.667L133.667 213.667V509.227C133.667 522.725 144.609 533.667 158.107 533.667H549.227C562.725 533.667 573.667 522.725 573.667 509.227V400.333L360.333 253.667Z",
      fill: "#185C37"
    }), /*#__PURE__*/_jsx("path", {
      d: "M360.333 0.333252H158.107C144.609 0.333252 133.667 11.2753 133.667 24.7732V133.667L360.333 267L480.333 307L573.667 267V133.667L360.333 0.333252Z",
      fill: "#21A366"
    }), /*#__PURE__*/_jsx("path", {
      d: "M133.667 133.667H360.333V267H133.667V133.667Z",
      fill: "#107C41"
    }), /*#__PURE__*/_jsx("path", {
      opacity: "0.1",
      d: "M295.893 107H133.667V440.333H295.893C309.373 440.29 320.29 429.373 320.333 415.893V131.44C320.29 117.96 309.373 107.044 295.893 107Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      opacity: "0.2",
      d: "M282.56 120.333H133.667V453.667H282.56C296.04 453.623 306.956 442.706 307 429.227V144.773C306.956 131.294 296.04 120.377 282.56 120.333Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      opacity: "0.2",
      d: "M282.56 120.333H133.667V427H282.56C296.04 426.956 306.956 416.04 307 402.56V144.773C306.956 131.294 296.04 120.377 282.56 120.333Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      opacity: "0.2",
      d: "M269.227 120.333H133.667V427H269.227C282.706 426.956 293.623 416.04 293.667 402.56V144.773C293.623 131.294 282.706 120.377 269.227 120.333Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24.7732 120.333H269.226C282.724 120.333 293.666 131.275 293.666 144.773V389.226C293.666 402.724 282.724 413.666 269.226 413.666H24.7732C11.2753 413.667 0.333252 402.724 0.333252 389.227V144.773C0.333252 131.275 11.2753 120.333 24.7732 120.333Z",
      fill: "url(#paint0_linear_1_40)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M76.0266 346.44L127.44 266.773L80.3333 187.547H118.227L143.933 238.213C146.307 243.027 147.933 246.6 148.813 248.96H149.147C150.808 245.177 152.587 241.446 154.48 237.773L181.96 187.573H216.746L168.44 266.333L217.973 346.44H180.96L151.267 290.827C149.868 288.461 148.681 285.975 147.72 283.4H147.28C146.41 285.923 145.256 288.338 143.84 290.6L113.267 346.44H76.0266Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M549.227 0.333252H360.333V133.667H573.667V24.7732C573.667 11.2753 562.725 0.333252 549.227 0.333252Z",
      fill: "#33C481"
    }), /*#__PURE__*/_jsx("path", {
      d: "M360.333 267H573.667V400.333H360.333V267Z",
      fill: "#107C41"
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_1_40",
        x1: "51.2911",
        y1: "101.236",
        x2: "242.709",
        y2: "432.763",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#18884F"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.5",
          stopColor: "#117E43"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#0B6631"
        })]
      })
    })]
  }));
};

ExcelIcon.defaultProps = {
  width: "574",
  height: "534",
  viewBox: "0 0 574 534",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var NumbersIcon = function NumbersIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_3_2)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M122.539 0H411.462C479.348 0 534 54.6529 534 122.539V411.461C534 479.348 479.348 534 411.462 534H122.539C54.6529 534 0 479.348 0 411.461V122.539C0 54.6529 54.6529 0 122.539 0V0Z",
        fill: "url(#paint0_linear_3_2)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M177.365 263.186H255.558C256.443 263.186 257.292 263.538 257.918 264.164C258.544 264.789 258.895 265.638 258.895 266.524V400.977C258.895 401.862 258.544 402.711 257.918 403.337C257.292 403.963 256.443 404.314 255.558 404.314H177.365C176.48 404.314 175.631 403.963 175.005 403.337C174.379 402.711 174.027 401.862 174.027 400.977V266.524C174.027 265.638 174.379 264.789 175.005 264.164C175.631 263.538 176.48 263.186 177.365 263.186V263.186Z",
        fill: "url(#paint1_linear_3_2)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M78.1981 343.286H158.077C159.454 343.286 160.572 344.309 160.572 345.572V402.029C160.572 403.291 159.454 404.314 158.077 404.314H78.1981C76.821 404.314 75.7036 403.291 75.7036 402.029V345.572C75.7036 344.31 76.821 343.286 78.1981 343.286Z",
        fill: "url(#paint2_linear_3_2)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M276.155 103.045H354.348C356.191 103.045 357.685 104.537 357.685 106.378V400.983C357.685 401.421 357.598 401.854 357.43 402.259C357.263 402.663 357.017 403.03 356.707 403.34C356.397 403.649 356.029 403.894 355.624 404.062C355.219 404.229 354.786 404.315 354.348 404.314H276.155C274.311 404.314 272.817 402.823 272.817 400.983V106.378C272.818 105.94 272.904 105.506 273.072 105.102C273.24 104.697 273.486 104.33 273.796 104.02C274.106 103.711 274.474 103.465 274.878 103.298C275.283 103.131 275.717 103.045 276.155 103.045V103.045Z",
        fill: "url(#paint3_linear_3_2)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M374.608 191.207H453.475C455.132 191.207 456.475 192.603 456.475 194.325V401.196C456.475 402.918 455.132 404.314 453.475 404.314H374.608C372.951 404.314 371.607 402.918 371.607 401.196V194.325C371.607 192.603 372.95 191.207 374.608 191.207Z",
        fill: "url(#paint4_linear_3_2)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M80.4917 419.809H452.146C456.36 419.809 459.775 422.587 459.775 426.014V427.921C459.775 431.348 456.36 434.125 452.146 434.125H80.4917C76.2784 434.125 72.8628 431.348 72.8628 427.921V426.014C72.8628 422.587 76.2784 419.809 80.4917 419.809Z",
        fill: "url(#paint5_linear_3_2)"
      })]
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_3_2",
        x1: "266.755",
        y1: "531.887",
        x2: "267.275",
        y2: "6.48899",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#11D51D"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#82FA6C"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_3_2",
        x1: "220.473",
        y1: "104.365",
        x2: "214.752",
        y2: "431.44",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint2_linear_3_2",
        x1: "122.881",
        y1: "102.655",
        x2: "117.159",
        y2: "429.733",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint3_linear_3_2",
        x1: "317.834",
        y1: "106.068",
        x2: "312.112",
        y2: "433.142",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint4_linear_3_2",
        x1: "417.365",
        y1: "107.809",
        x2: "411.643",
        y2: "434.884",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint5_linear_3_2",
        x1: "271.947",
        y1: "105.265",
        x2: "266.225",
        y2: "432.34",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_3_2",
        children: /*#__PURE__*/_jsx("rect", {
          width: "534",
          height: "534",
          fill: "white"
        })
      })]
    })]
  }));
};

NumbersIcon.defaultProps = {
  width: "534",
  height: "534",
  viewBox: "0 0 534 534",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var FileTableIcon = function FileTableIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_6226_1578)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M27.6249 0H19.8749V50.3749H0.5V58.1248H19.8749V77.4998H27.6249V58.1248H62.4998V50.3749H27.6249V0Z",
        fill: "#696C80"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M41.928 0.428509C40.1351 -0.00193591 38.2759 -0.00105084 35.8153 0.000119701L22.8149 0.000242575C19.6956 0.000193148 17.1212 0.000152496 15.0241 0.171494C12.846 0.349454 10.8438 0.731389 8.96312 1.68964C6.04662 3.17567 3.67543 5.54686 2.1894 8.46337C1.23115 10.344 0.849214 12.3463 0.671255 14.5244C0.499914 16.6215 0.499954 19.1959 0.500002 22.3151V55.1851C0.499954 58.3043 0.499914 60.8788 0.671255 62.9759C0.849214 65.154 1.23115 67.1562 2.1894 69.0369C3.67543 71.9534 6.04662 74.3246 8.96312 75.8106C10.8438 76.7689 12.846 77.1508 15.0241 77.3288C17.1212 77.5001 19.6956 77.5001 22.8148 77.5H40.185C43.3042 77.5001 45.8785 77.5001 47.9756 77.3288C50.1538 77.1508 52.156 76.7689 54.0366 75.8106C56.9531 74.3246 59.3243 71.9534 60.8104 69.0369C61.7686 67.1562 62.1506 65.154 62.3285 62.9759C62.4999 60.8787 62.4998 58.3044 62.4998 55.1851L62.4999 26.6847C62.501 24.2242 62.5019 22.3649 62.0715 20.572C61.6918 18.9905 61.0655 17.4785 60.2157 16.0917C59.2523 14.5195 57.937 13.2055 56.1963 11.4664L51.0336 6.30375C49.2945 4.56301 47.9805 3.24774 46.4083 2.28431C45.0215 1.43447 43.5096 0.808207 41.928 0.428509ZM35.3749 7.75022H22.9749C19.6557 7.75022 17.3993 7.75323 15.6552 7.89573C13.9564 8.03453 13.0876 8.28612 12.4815 8.59492C11.0233 9.33793 9.83769 10.5235 9.09467 11.9818C8.78587 12.5878 8.53429 13.4566 8.39549 15.1555C8.25299 16.8996 8.24998 19.1559 8.24998 22.4752V55.0251C8.24998 58.3443 8.25299 60.6007 8.39549 62.3448C8.53429 64.0436 8.78587 64.9124 9.09467 65.5185C9.83769 66.9767 11.0233 68.1623 12.4815 68.9053C13.0876 69.2141 13.9564 69.4657 15.6552 69.6045C17.3993 69.747 19.6557 69.75 22.9749 69.75H40.0248C43.3441 69.75 45.6005 69.747 47.3445 69.6045C49.0434 69.4657 49.9122 69.2141 50.5182 68.9053C51.9765 68.1623 53.1621 66.9767 53.9051 65.5185C54.2139 64.9124 54.4655 64.0436 54.6043 62.3448C54.7468 60.6007 54.7498 58.3443 54.7498 55.0251V27.1249H46.9998C40.5795 27.1249 35.3749 21.9202 35.3749 15.5V7.75022ZM53.0445 19.3749C52.5788 18.8243 51.8352 18.0656 50.437 16.6674L45.8326 12.0631C44.4342 10.6647 43.6755 9.92097 43.1248 9.45531V15.5C43.1248 17.64 44.8597 19.3749 46.9998 19.3749H53.0445Z",
        fill: "#696C80"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_6226_1578",
        children: /*#__PURE__*/_jsx("rect", {
          width: "62",
          height: "77.5",
          fill: "white",
          transform: "translate(0.5)"
        })
      })
    })]
  }));
};

FileTableIcon.defaultProps = {
  width: "63",
  height: "78",
  viewBox: "0 0 63 78",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const icons = {
  'google-sheets': /*#__PURE__*/_jsx(GoogleSheetsIcon, {}),
  excel: /*#__PURE__*/_jsx(ExcelIcon, {}),
  numbers: /*#__PURE__*/_jsx(NumbersIcon, {}),
  unknown: /*#__PURE__*/_jsx(FileTableIcon, {
    className: styles.fileTableIcon
  })
};

const WorkbookIcon = _ref => {
  let {
    className,
    originFileType,
    defaultIcon
  } = _ref;
  const originType = useMemo(() => {
    if (!originFileType) return defaultIcon || 'unknown';
    const result = getFileOriginEditor(originFileType);
    if (result === 'unknown' && defaultIcon) return defaultIcon;
    return result;
  }, [originFileType, defaultIcon]);
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles.icon, className),
    "data-origin-type": originType,
    children: icons[originType]
  });
};

export default WorkbookIcon;